
import { ArrowLeft, Github, Globe } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CustomCursor from "../components/CustomCursor";

const OnlineStoreProject = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white p-8">
      <CustomCursor />
      <Link 
        to="/" 
        className="inline-flex items-center text-yellow-300 hover:text-yellow-400 transition-colors mb-8"
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to Portfolio
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto"
      >
        <h1 className="text-4xl font-bold mb-6 text-yellow-300">E-Commerce Website Development</h1>
        <p className="text-gray-300 mb-8">Jan 2024 - May 2024</p>

        <div className="grid gap-8 md:grid-cols-2 mb-12">
          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">Custom Design</h3>
            </div>
            <p className="text-gray-300">
              Designed and customized a visually appealing e-commerce site on Wix, incorporating brand's logo and product images to enhance user engagement.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">Payment Integration</h3>
            </div>
            <p className="text-gray-300">
              Integrated PayPal for seamless transactions, added product listings, and activated search features for improved navigation.
            </p>
          </motion.div>
        </div>

        <div className="bg-gray-800/30 p-8 rounded-xl backdrop-blur-sm mb-8">
          <h2 className="text-2xl font-bold mb-4 text-yellow-300">Technical Stack</h2>
          <div className="flex flex-wrap gap-3">
            {["Wix", "E-Commerce", "PayPal", "UI/UX Design", "Product Management"].map((tech) => (
              <span 
                key={tech}
                className="bg-yellow-300/10 text-yellow-300 px-3 py-1 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div className="flex gap-4">
          <a
            href="https://github.com/your-github/online-store"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-yellow-300 text-black px-4 py-2 rounded-lg hover:bg-yellow-400 transition-colors"
          >
            <Github className="h-5 w-5" />
            View on GitHub
          </a>
          <a
            href="https://your-store-url.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
          >
            <Globe className="h-5 w-5" />
            Live Demo
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default OnlineStoreProject;
